module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headpage"
  }, [_c('div', {
    staticClass: "a-header",
    style: ({
      backgroundColor: _vm.skinColor
    })
  }, [_c('div', {
    staticClass: "headerwrap clearfix"
  }, [_c('div', {
    staticClass: "left-header fl",
    on: {
      "click": _vm.toggleSideBar
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  }), _vm._v(" "), _c('img', {
    staticClass: "a-user-pic",
    attrs: {
      "src": "https://ooo.0o0.ooo/2017/06/30/595605552345a.png",
      "alt": "user-pic"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ac-Logo",
    attrs: {
      "src": "https://ooo.0o0.ooo/2017/06/29/5954b017c80a7.png",
      "alt": "ac-Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-header fr"
  }, [_c('i', {
    staticClass: "fa fa-gamepad"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-history"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search",
    on: {
      "click": _vm.searchShow
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "a-navbar"
  }, [_c('ul', [_c('li', {
    staticClass: "a-follow"
  }, [_c('router-link', {
    attrs: {
      "to": "/follow"
    }
  }, [_vm._v("关注")])], 1), _vm._v(" "), _c('li', {
    staticClass: "a-recommend"
  }, [_c('router-link', {
    attrs: {
      "to": "/recommend"
    }
  }, [_vm._v("推荐")])], 1), _vm._v(" "), _c('li', {
    staticClass: "a-drama"
  }, [_c('router-link', {
    attrs: {
      "to": "/drama"
    }
  }, [_vm._v("番剧")])], 1), _vm._v(" "), _c('li', {
    staticClass: "a-disport"
  }, [_c('router-link', {
    attrs: {
      "to": "/disport"
    }
  }, [_vm._v("娱乐")])], 1), _vm._v(" "), _c('li', {
    staticClass: "a-article"
  }, [_c('router-link', {
    attrs: {
      "to": "/article"
    }
  }, [_vm._v("文章")])], 1), _vm._v(" "), _c('li', {
    staticClass: "a-channel"
  }, [_c('router-link', {
    attrs: {
      "to": "/channel"
    }
  }, [_vm._v("频道")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "a-content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fold"
    }
  }, [(_vm.sideBarShow) ? _c('div', {
    staticClass: "a-sidebar"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('img', {
    attrs: {
      "src": "https://ooo.0o0.ooo/2017/06/30/595605552345a.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), (_vm.isShowSkin) ? _c('i', {
    staticClass: "fa fa-moon-o",
    on: {
      "click": function($event) {
        _vm.changeColor('black')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isShowSkin) ? _c('i', {
    staticClass: "fa fa-sun-o",
    on: {
      "click": function($event) {
        _vm.changeColor('#fd4c5d')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "user-desc"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_c('span', [_vm._v("Tancky")])]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "user-grade"
  }, [_vm._v("LV 12")]), _vm._v(" "), _c('span', {
    staticClass: "user-vip"
  }, [_vm._v("正式会员")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ooo.0o0.ooo/2017/06/29/5954b623af533.png",
      "alt": "banana"
    }
  }), _vm._v(" "), _c('span', [_vm._v("3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "a-sideItem"
  }, [_c('div', {
    staticClass: "SignIn",
    style: (_vm.signIn),
    on: {
      "click": _vm.sign
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.message))]), _vm._v("  " + _vm._s(_vm.getBanana) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "sidelist"
  }, [_c('li', [_c('img', {
    staticClass: "tag",
    attrs: {
      "src": require("../assets/img/play_history.png"),
      "width": "24",
      "height": "24"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("历史记录")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "tag",
    attrs: {
      "src": require("../assets/img/downloaded.png"),
      "width": "24",
      "height": "24"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("离线缓存")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "tag",
    attrs: {
      "src": require("../assets/img/ic_following_and_followers.png"),
      "width": "24",
      "height": "24"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("关注和粉丝")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "tag",
    attrs: {
      "src": require("../assets/img/favorites.png"),
      "width": "24",
      "height": "24"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("我的收藏")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "tag",
    attrs: {
      "src": require("../assets/img/uploaded.png"),
      "width": "24",
      "height": "24"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("我的投稿")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "tag",
    attrs: {
      "src": require("../assets/img/game_center.png"),
      "width": "24",
      "height": "24"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("游戏中心")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "tag",
    attrs: {
      "src": require("../assets/img/market.png"),
      "width": "25",
      "height": "24"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("周边商城")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "tag",
    attrs: {
      "src": require("../assets/img/settings.png"),
      "width": "24",
      "height": "24"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("设置")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "tag",
    attrs: {
      "src": require("../assets/img/feedback.png"),
      "width": "24",
      "height": "24"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("意见反馈")])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sideBarShow),
      expression: "sideBarShow"
    }]
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.toggleSideBar
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.searchbarShow) ? _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "searchBar"
  }, [_c('div', {
    staticClass: "s-head"
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入关键词或AC号"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchSub($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search ",
    on: {
      "click": _vm.searchSub
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isListShow),
      expression: "isListShow"
    }],
    staticClass: "searchList"
  }, [_c('ul', _vm._l((_vm.searchList), function(list) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.searchPlay(list.aid, list.title, list.description, list.author)
        }
      }
    }, [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": list.pic,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(list.title))]), _vm._v(" "), _c('span', {
      staticClass: "author"
    }, [_vm._v("UP主: " + _vm._s(list.author))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "s-hot"
  }, [_c('h2', [_vm._v("热门搜索")]), _vm._v(" "), _c('ul', {
    staticClass: "hot-list"
  }, [_c('li', [_vm._v("木鱼微剧场")]), _vm._v(" "), _c('li', [_vm._v("评论才是本体")]), _vm._v(" "), _c('li', [_vm._v("宇宙大新闻")]), _vm._v(" "), _c('li', [_vm._v("越狱")]), _vm._v(" "), _c('li', [_vm._v("野食小哥")]), _vm._v(" "), _c('li', [_vm._v("奥雷")]), _vm._v(" "), _c('li', [_vm._v("瞎看什么")]), _vm._v(" "), _c('li', [_vm._v("STN快报")]), _vm._v(" "), _c('li', [_vm._v("中国交通事故合集")]), _vm._v(" "), _c('li', [_vm._v("暴走大事件")])])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e0833e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 102
// module chunks = 0